import { Type } from 'class-transformer';
import { IsOptional, ValidateNested } from 'class-validator';
import { PropertyId } from '../../../types';
import { BetaRegistrationPopulateDto } from '../../business/etxe';
import { UserRegistrationCreatedByPopulateDto } from '../../user-registration';
import { UserCreatedByPopulateDto } from '../../users';

export class TokenVaultContextDto {
  // ─── Core contexts ──────────────────────────────────────────────────────────
  @ValidateNested()
  @Type(() => UserCreatedByPopulateDto)
  @IsOptional()
  user?: UserCreatedByPopulateDto;

  @ValidateNested()
  @Type(() => UserRegistrationCreatedByPopulateDto)
  @IsOptional()
  userRegistration?: UserRegistrationCreatedByPopulateDto;

  @ValidateNested()
  @Type(() => BetaRegistrationPopulateDto)
  @IsOptional()
  betaRegistration?: BetaRegistrationPopulateDto;

  // ─── Business contexts (ETXE) ───────────────────────────────────────────────
  @IsOptional()
  property?: PropertyId;
}
